import { connect } from 'react-redux';
import { RefundViewerComponent } from '../../components';
import { addComment, updateReturnedRefund, uploadFiles, fetchTicket, updateStatus, getRefundsCount, getTransactions } from '../../redux/actions/refunds';
import { getAllOperatorData as getOperatorData } from '../../redux/actions/operator';
import { withRouter } from 'react-router';

const mapStateToProps = state => ({
  operators: state.operator.allData,
  loading: state.refunds.loading,
  uploading: state.refunds.uploading,
  refundCount: state.refunds.refundCount,
  ticket: {
    ...state.refunds.refund,
    ...(state.refunds.refund ? {srvcId: state.refunds.refund.srvcId.toString()} : {})
  },
  userRoles: state.auth.user.roles,
  transactions: state.refunds.transactions,
  loadingTransactions: state.refunds.loadingTransactions
})

const mapDispatchToProps = {
  addComment,
  updateReturnedRefund,
  uploadFiles,
  getOperatorData,
  fetchTicket,
  updateStatus,
  getRefundsCount,
  getTransactions
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RefundViewerComponent));



// WEBPACK FOOTER //
// ./src/containers/RefundViewer/RefundViewer.js